/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionResume } from '../../axios/subscriptionResume'
import type {
	SubscriptionResumeError,
	SubscriptionResumePathParams,
	SubscriptionResumeResponse,
} from '../../types/SubscriptionResume'

export const subscriptionResumeMutationKey = () =>
	[{ url: '/:organisation/profiles/:profile/subscription/resume' }] as const

export type SubscriptionResumeMutationKey = ReturnType<typeof subscriptionResumeMutationKey>

export type SubscriptionResumeVariables = {
	organisation: SubscriptionResumePathParams['organisation']
	profile: SubscriptionResumePathParams['profile']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::resume */
export function useSubscriptionResume<TContext = unknown>(
	options?: UseMutationOptions<
		SubscriptionResumeResponse,
		AxiosError<SubscriptionResumeError>,
		SubscriptionResumeVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: subscriptionResumeMutationKey(),
		mutationFn: ({ organisation, profile }: SubscriptionResumeVariables) =>
			subscriptionResume(organisation, profile, config).then(res => res.data),
		...options,
	})
}
